const metaData = {
  fields: [
    'id',
    'section_id',
    'target_lang',
    'base_lang',
    { section: ['id', 'name'] },
    'name',
    'paper_template_id',
    'question_type_id',
    { question_type: ['id', 'name'] },
    'no_of_questions',
    'mark_per_question',
    'theme_id',
    'report_theme_id',
    { report_theme: ['id', 'name'] },
    { theme: ['id', 'name'] },
    'subject_id',
    { subject: ['id', 'name'] },
    'sub_theme_id',
    { sub_theme: ['id', 'name'] },
    'topic_id',
    { topic: ['id', 'name'] },
    'questionIds',
    'blooms_level_id',
    { bloom_level: ['id', 'name'] },
    'difficult_level_id',
    { difficulty_level: ['id', 'name'] },
    'competency_id',
    { competency: ['id', 'name'] },
    'strand_id',
    { strand: ['id', 'name'] },
  ],
}

export default metaData
